<template>
    <!-- 下载评价模板弹出框 -->
    <el-dialog title="下载评价模板" :close-on-click-modal="false" :visible.sync="visible" width="500px" center>
        <div>
            <div style="margin-bottom: 20px;">
                <span>评价类型</span>
            </div>
            <div style="margin-bottom: 20px;">
                <el-select v-model="templateForm.evaluateType" style="width: 100%" placeholder="请选择"
                    @change="evaluateTypeChange" clearable>
                    <el-option v-for="item in evaluateTypes" :key="item.id" :label="item.moduleTitle"
                        :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div style="margin-bottom: 20px;">
                <span>评价范围</span>
            </div>
            <div>
                <el-cascader style="width: 100%" :options="classList" v-model="templateForm.classId" :props="props"
                    collapse-tags clearable></el-cascader>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">关闭</el-button>
            <el-button type="primary" @click="downloadTemplate">确定下载</el-button>
        </span>
    </el-dialog>
</template>

<script>
import http from '../../../../common/http';

export default {
    name: "downloadTemplateDialog",
    data() {
        return {
            visible: false,
            props: { multiple: true, checkStrictly: true },
            templateForm: {
                deptId: '',
                classId: '',
                evaluateType: ''
            },
            classList: [],     // 班级列表
            evaluateTypes: [],  // 评价类型
        }
    },
    created() {
    },
    methods: {
        // 显示弹窗
        showDialog() {
            this.visible = true;
            // 用户信息
            let userinfo = JSON.parse(sessionStorage.getItem('userinfo'));
            // 重置表单
            this.templateForm = {
                deptId: userinfo.deptId,
                classId: [],
                evaluateType: ''
            };

            // this.getOrganizes()
            this.getModuleBindIndicators()
        },
        // 关闭弹窗
        closeDialog() {
            this.visible = false;
        },
        // 评价类型
        getModuleBindIndicators() {
            let url = this.moduleBindIndicatorsHavePermissionModuleListUrl;
            let data = {
                deptId: this.templateForm.deptId,
            };

            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    let evaluateTypes = []
                    res.data.forEach((item, index) => {
                        if(item.moduleTitle != '实践评价'){ 
                            evaluateTypes.push(item)
                        }
                    });
                    this.evaluateTypes = evaluateTypes
                    console.log('获取评价范围', this.evaluateTypes)
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
            });
        },
        // 评价范围
        async getOrganizes() {
            let url = this.getDeptAndMentorCascaderUrl
            let data = {
                deptId: this.templateForm.deptId,
                moduleId: this.templateForm.evaluateType
            };

            this.templateForm.classId = []
            this.classList = []
            await this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                        let datas = res.data.selects[0].children
                        if (!datas) {
                            return
                        }
                        this.classList = datas
                    } else {
                        this.$commonFn.showTip(res.message, 3)
                    }
                }, (err) => {
                    console.log(err)
                }
            )
        },
        // 评价类型变动
        async evaluateTypeChange(typeId) {
            if (this.$util.isEmpty(typeId)) {
                this.classList = []
                return
            }
            let evaluateTypeLabel = ""
            this.evaluateTypes.forEach(element => {
                if (typeId === element.id) {
                    evaluateTypeLabel = element.moduleTitle
                }
            });
            if (evaluateTypeLabel.indexOf('教职') > -1) {
                // 查询评价类型
                await this.getOrganizes()
                let evaluateRange = []
                this.classList.forEach((item, index) => {
                    if (item.label.indexOf('全校教职') > -1) {
                        evaluateRange.push(item)
                    }
                })
                this.classList = []
                this.classList = evaluateRange
            } else if(evaluateTypeLabel.indexOf('班级评价') > -1){
                console.log('班级评价', evaluateTypeLabel)
                // 查询评价类型
                await this.getOrganizes()
                let evaluateRange = []
                this.classList.forEach((item, index) => {
                    // console.log('班级评价', item)
                    if (item.label.indexOf('年级') > -1) {
                        delete item.children
                        evaluateRange.push(item)
                    }
                })
                this.classList = evaluateRange
            }else {
                // 查询评价类型
                await this.getOrganizes()
                let evaluateRange = []
                this.classList.forEach((item, index) => {
                    if (item.label.indexOf('年级') > -1 
                            || item.label.indexOf('_导师班')>-1) {
                        item.label = item.label.replace('_导师班','')
                        evaluateRange.push(item)
                    }
                })
                this.classList = evaluateRange
            }
        },
        // 下载评价模板
        downloadTemplate() {
            if (this.$util.isEmpty(this.templateForm.evaluateType)) {
                this.$commonFn.showTip("请选择评价类型", 2);
                return;
            }

            if (this.$util.isEmpty(this.templateForm.classId)) {
                this.$commonFn.showTip("请选择评价范围", 2);
                return;
            }

            let classIdArr = new Array()
            for (let i = 0; i < this.templateForm.classId.length; i++) {
                let classIds = this.templateForm.classId[i]
                // {type:1,id:""}，type: 1-年级，2-班级
                let classIdObj = {}
                if (classIds.length == 1) {
                    classIdObj['type'] = 1
                    classIdObj['id'] = classIds[0]
                    classIdArr.push(classIdObj)
                } else {
                    classIdObj['type'] = 2
                    classIdObj['id'] = classIds[classIds.length - 1]
                    classIdArr.push(classIdObj)
                }
            }
            // 请求参数
            let data = {}
            if(classIdArr.length === 0){
                data = { 'classId': '', 'moduleId': this.templateForm.evaluateType }
            }else{
                data = { 'classId': JSON.stringify(classIdArr), 'moduleId': this.templateForm.evaluateType }
            }
            // 模块名称
            let moduleTitle = ''
            this.evaluateTypes.forEach((item, index) => {
                if (item.id === this.templateForm.evaluateType) {
                    moduleTitle = item.moduleTitle
                }
            })

            if(moduleTitle.indexOf('班级评价') >-1 ){
                this.$exportFile("/api/business/evaluateDetail/downloadTemplate", data, moduleTitle + `模板.xls`)
            }else{
                this.$exportFile("/api/business/evaluateDetail/downloadTemplate", data, moduleTitle + `模板.zip`)
            }
        }
    },
    mixins: [http]
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/DownloadTemplateDialog.vue